import React, {useState, useCallback} from 'react';
import {Modal, ActivityIndicator, StyleSheet, View} from 'react-native';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {useTheme} from 'styled-components/native';
import {verificarElegibilidade} from '../../../services/creditoMova';

import {
  Overlay,
  ModalCard,
  IconWrapper,
  Icon,
  Title,
  Description,
  ActionButton,
  ActionButtonText,
} from './styles';

export function EmprestimoEligibilityGate() {
  const navigation = useNavigation();
  const theme = useTheme();
  const [status, setStatus] = useState<'checking' | 'blocked' | 'allowed'>(
    'checking',
  );

  useFocusEffect(
    useCallback(() => {
      let cancelled = false;

      (async () => {
        setStatus('checking');
        try {
          const {elegivel} = await verificarElegibilidade();
          if (cancelled) {return;}
          setStatus(elegivel ? 'allowed' : 'blocked');
        } catch {
          if (cancelled) {return;}
          setStatus('blocked');
        }
      })();

      return () => {
        cancelled = true;
      };
    }, []),
  );

  const handleGoBack = () => {
    navigation.navigate('Initial');
    setStatus('checking');
  };

  if (status === 'allowed') {
    return null;
  }

  if (status === 'checking') {
    return (
      <View
        style={[
          StyleSheet.absoluteFill,
          {
            backgroundColor: theme.colors.background,
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          },
        ]}>
        <ActivityIndicator size="large" color={theme.colors.primary} />

      </View>
    );
  }

  return (
    <Modal transparent animationType="fade" visible>
      <Overlay>
        <ModalCard>
          <IconWrapper>
  <Icon name="clock" />
</IconWrapper>
<Title>Analisando seu perfil</Title>
<Description>
 Ainda estamos analisando o seu perfil para liberar o crédito com as
melhores condições possíveis. Assim que tudo estiver certo, você será
avisado por aqui.
</Description>
          <ActionButton activeOpacity={0.8} onPress={handleGoBack}>
            <ActionButtonText>Voltar ao início</ActionButtonText>
          </ActionButton>
        </ModalCard>
      </Overlay>
    </Modal>
  );
}
